import './custom.js'
// -- Split menu -- //
// const splitMenu = () => {
// 	const menuWrapper = document.querySelector('#navigation .navigation-in')
// 	if (menuWrapper) {
// 		setTimeout(() => {
// 			let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category):not(#nav-manufacturers)')
// 			let menuHelper = document.querySelector('.menu-helper')
// 			menuItems.forEach((item) => {
// 				let offsetRight = item.offsetLeft + item.offsetWidth
// 				if (offsetRight > menuWrapper.clientWidth) {
// 					let splitted
// 					if (!item.id == 'nav-manufacturers') {
// 						splitted = menuHelper.querySelector('.' + item.classList[0])
// 					} else {
// 						splitted = menuHelper.querySelector('#nav-manufacturers')
// 					}
// 					if (splitted) {
// 						splitted.classList.remove('splitted')
// 					}
// 					item.classList.add('splitted')
// 				} else {
// 					let splitted = menuHelper.querySelector('.' + item.classList[0])
// 					if (splitted) {
// 						splitted.classList.add('splitted')
// 					}
// 					item.classList.remove('splitted')
// 				}
// 			})
// 			if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category):not(#nav-manufacturers)')) {
// 				menuHelper.classList.remove('empty')
// 				menuWrapper.classList.remove('fitted')
// 			} else {
// 				menuHelper.classList.add('empty')
// 				menuWrapper.classList.add('fitted')
// 			}
// 		}, 200)
// 	}
// }
const splitMenu = () => {
	const menuWrapper = document.querySelector('#navigation .navigation-in')
	if (menuWrapper) {
		setTimeout(() => {
			let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category)')
			let menuHelper = document.querySelector('.menu-helper')
			let menuWrapperStyle = window.getComputedStyle(menuWrapper)
			menuItems.forEach((item) => {
				let offsetRight = item.offsetLeft + item.offsetWidth
				const itemInHelper =
					item.id === 'nav-manufacturers'
						? menuHelper.querySelector('#nav-manufacturers')
						: menuHelper.querySelector('.' + item.classList[0])
				if (offsetRight > menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)) {
					if (itemInHelper) {
						itemInHelper.classList.remove('splitted')
					}
					item.classList.add('splitted')
				} else {
					if (itemInHelper) {
						itemInHelper.classList.add('splitted')
					}
					item.classList.remove('splitted')
				}
			})
			if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category)')) {
				menuHelper.classList.remove('empty')
				menuWrapper.classList.remove('fitted')
			} else {
				menuHelper.classList.add('empty')
				menuWrapper.classList.add('fitted')
			}
		}, 200)
	}
}

shoptet.menu.splitMenu = splitMenu

// CAROUSEL
const handleCarousel = () => {
	const carousel = document.querySelector('#carousel .carousel-inner')
	if (carousel) {
		let observer = new MutationObserver((mutationList) => {
			let currentItem
			mutationList.forEach((mutation) => {
				if (mutation.target.className === 'item active') {
					currentItem = mutation.target
				}
			})
			if (typeof currentItem == 'undefined') return
			let actualIndex = [...document.querySelectorAll('.carousel-inner .item')].indexOf(currentItem),
				dotsList = document.querySelectorAll('.carousel-dots li')
			dotsList.forEach((dot) => {
				dot.classList.remove('dot-active')
			})
			dotsList[actualIndex].classList.add('dot-active')
		})
		let dotsCounter = 0,
			dotsList = document.createElement('ul')
		dotsList.classList.add('carousel-dots')
		carousel.querySelectorAll('.item').forEach((item, index) => {
			dotsCounter += 1
			let dotEl = document.createElement('li')
			dotsList.appendChild(dotEl)
			if (index === 0) dotEl.classList.add('dot-active')
			dotEl.addEventListener('click', (e) => {
				e.preventDefault()
				document.querySelector('.carousel-inner .item.active').classList.remove('active')
				let targetItem = document.querySelectorAll('.carousel-inner .item')[index]
				const targetItemImg = targetItem.querySelector('img')
				if (!targetItemImg.src) targetItemImg.src = targetItemImg.getAttribute('data-src')
				targetItem.classList.add('active')
			})
			observer.observe(item, {
				attributes: true,
				attributeFilter: ['class'],
			})
		})
		if (window.innerWidth <= 767) {
			let carouselTextsMinHeight = 0
			const carouselTexts = carousel.querySelectorAll('.extended-banner-texts')
			const carouselHelper = document.createElement('div')
			carouselHelper.id = 'carousel'
			document.body.appendChild(carouselHelper)
			carouselTexts.forEach((texts) => {
				const clone = texts.cloneNode(true)
				carouselHelper.appendChild(clone)
				if (clone.offsetHeight > carouselTextsMinHeight) {
					carouselTextsMinHeight = clone.offsetHeight
				}
			})
			carouselHelper.remove()
			carousel.parentElement.style.setProperty(`--min-texts-height`, `${carouselTextsMinHeight}px`)
		}
		carousel.appendChild(dotsList)
	}
}
handleCarousel()

// FLAGS
const handleFlags = (product) => {
	const flagsDefault = product.querySelector('.flags-default')
	const flagsExtra = product.querySelector('.flags-extra')
	const priceStandard = product.querySelector('.price-standard')
	const prices = product.querySelector('.prices')
	// if (priceStandard && prices) prices.prepend(priceStandard);
	if (flagsDefault && flagsExtra) {
		flagsDefault.appendChild(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}
	const flagdiscount = product.querySelector('.flag-discount')
	if (!flagdiscount) return
	if (flagdiscount.textContent.includes('od') && flagdiscount.textContent.includes('až')) {
		flagdiscount.childNodes.forEach((node) => {
			if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('od')) {
				node.textContent = node.textContent.replace('od', '').trim()
			}
		})
	}
}

// RATINGS
const handleRatings = (product) => {
	if (product.querySelector('.custom-ratings')) return
	const ratingsValue = product.querySelector('.stars-wrapper')
	const productImage = product.querySelector('.image')
	if (ratingsValue) {
		const customRatings = document.createElement('div')
		customRatings.classList.add('custom-ratings', 'stars')
		customRatings.innerHTML = `
			${ratingsValue.getAttribute('data-micro-rating-value') || 0} <span class="star star-on"></span> 
		`
		productImage.appendChild(customRatings)
	}
}
// AVAILABILITY
// const handleProductAvailability = (product) => {
//   const availability = product.querySelector(".availability");
//   const pBottom = product.querySelector(".p-bottom > div");
//   const pPrices = product.querySelector(".p-bottom .prices");
//   if (availability && pBottom && pPrices) {
//     const pBottomAvailPrices = document.createElement("div");
//     pBottomAvailPrices.classList.add("availability-prices");
//     pBottomAvailPrices.appendChild(availability);
//     pBottomAvailPrices.appendChild(pPrices);
//     pBottom.prepend(pBottomAvailPrices);
//   }
// };
// const handleProductAddToCartButton = (product) => {
//   const addToCartButton = product.querySelector(".add-to-cart-button > span");
//   if (addToCartButton)
//     addToCartButton.innerText = window.mmLanguage === "sk" ? "Kúpiť" : "Koupit";
// };

// const moveAddToFavorites = (product) => {
//   const addToFavoritesWrap = product.querySelector(".dkLabFavouriteProductDiv");
//   const pTools = product.querySelector(".p-tools");
//   if (!addToFavoritesWrap || !pTools) return;
//   product.setAttribute("data-favoriteModified", "true");
//   pTools.prepend(addToFavoritesWrap);
// };

// const mmAllProducts = document.querySelectorAll(".products-block .product");
// if (mmAllProducts.length) {
//   mmAllProducts.forEach((product) => handleFlags(product));
//   mmAllProducts.forEach((product) => handleRatings(product));
//   mmAllProducts.forEach((product) => handleProductAvailability(product));
//   mmAllProducts.forEach((product) => handleProductAddToCartButton(product));
//   mmAllProducts.forEach((product) => {
//     window.waitFor(".dkLabFavouriteProductDiv").then(() => {
//       moveAddToFavorites(product);
//     });
//   });
// }
// document.addEventListener("ShoptetDOMContentLoaded", () => {
//   const mmAllProducts = document.querySelectorAll(".products-block .product");
//   if (mmAllProducts.length) {
//     mmAllProducts.forEach((product) => handleFlags(product));
//     mmAllProducts.forEach((product) => handleRatings(product));
//     mmAllProducts.forEach((product) => handleProductAvailability(product));
//     mmAllProducts.forEach((product) => handleProductAddToCartButton(product));
//     mmAllProducts.forEach((product) => {
//       window.waitFor(".dkLabFavouriteProductDiv").then(() => {
//         moveAddToFavorites(product);
//       });
//     });
//   }
// });
const handleProductMoreButton = (product) => {
	const desc = product.querySelector('.p-desc')
	if (!desc) return

	const haveMoreButton = desc.querySelector('.more-button')
	if (haveMoreButton) return

	let textWrapper = desc.querySelector('.p-desc-text')
	if (!textWrapper) {
		textWrapper = document.createElement('div')
		textWrapper.classList.add('p-desc-text')

		while (desc.firstChild) {
			textWrapper.appendChild(desc.firstChild)
		}
		desc.appendChild(textWrapper)
	}

	const moreButton = document.createElement('a')
	moreButton.classList.add('more-button')
	const productLink = product.querySelector('a.image').href
	moreButton.href = `${productLink}/#description`
	moreButton.textContent = 'Zjistit více'

	desc.appendChild(moreButton)
}

const handleProductAvailability = (product) => {
	const availability = product.querySelector('.ratings-wrapper')
	const code = product.querySelector('.p-code')
	if (availability && code) {
		availability.prepend(code)
	}
}

const handlePriceStandard = (product) => {
	const priceStandard = product.querySelector('.flag-discount .price-standard')
	const prices = product.querySelector('.p-bottom .prices')
	if (priceStandard && prices) prices.prepend(priceStandard)
}
const createQuantity = () => {
	let quantityWrapper = document.createElement('span'),
		increaseTooltip = document.createElement('span'),
		descreseTooltip = document.createElement('span'),
		increaseEl = document.createElement('span'),
		decreaseEl = document.createElement('span'),
		quantityInput = document.createElement('input')

	quantityWrapper.classList.add('quantity')
	increaseTooltip.classList.add('increase-tooltip', 'js-increase-tooltip')
	increaseTooltip.setAttribute('data-trigger', 'manual')
	increaseTooltip.setAttribute('data-container', 'body')
	increaseTooltip.setAttribute('data-original-title', 'Není možné objednat více než 9999 kusů.')
	increaseTooltip.setAttribute('aria-hidden', true)
	increaseTooltip.setAttribute('role', 'tooltip')

	descreseTooltip.classList.add('increase-tooltip', 'js-increase-tooltip')
	descreseTooltip.setAttribute('data-trigger', 'manual')
	descreseTooltip.setAttribute('data-container', 'body')
	descreseTooltip.setAttribute('data-original-title', 'Minimální množství, které lze zakoupit je 1 kus.')
	descreseTooltip.setAttribute('aria-hidden', true)
	descreseTooltip.setAttribute('role', 'tooltip')

	increaseEl.classList.add('increase')
	increaseEl.setAttribute('aria-label', 'Zvýšit množství')
	increaseEl.setAttribute('tabindex', '0')
	increaseEl.setAttribute('role', 'button')
	increaseEl.setAttribute('data-testid', 'increase')

	decreaseEl.classList.add('decrease')
	decreaseEl.setAttribute('aria-label', 'Snížit množství')
	decreaseEl.setAttribute('tabindex', '0')
	decreaseEl.setAttribute('role', 'button')
	decreaseEl.setAttribute('data-testid', 'decrease')

	quantityInput.classList.add('amount')
	quantityInput.setAttribute('type', 'number')
	quantityInput.setAttribute('name', 'amount')
	quantityInput.setAttribute('value', '1')
	quantityInput.setAttribute('autocomplete', 'off')
	quantityInput.setAttribute('data-decimals', '0')
	quantityInput.setAttribute('data-max', '9999')
	quantityInput.setAttribute('data-min', '1')
	quantityInput.setAttribute('step', '1')
	quantityInput.setAttribute('min', '1')
	quantityInput.setAttribute('max', '9999')
	quantityInput.setAttribute('data-testid', 'cartAmount')
	quantityInput.setAttribute('aria-label', 'Množství')

	quantityWrapper.appendChild(increaseTooltip)
	quantityWrapper.appendChild(descreseTooltip)
	quantityWrapper.appendChild(quantityInput)
	quantityWrapper.appendChild(increaseEl)
	quantityWrapper.appendChild(decreaseEl)

	return quantityWrapper
}
const handleOnDemandProducts = (product) => {
	if (!product) return

	const priceElement = product.querySelector('[data-micro-price]')
	const addToCartWrapper = product.querySelector('.p-tools')

	if (!priceElement || !addToCartWrapper) return

	const price = parseFloat(priceElement.getAttribute('data-micro-price'))

	if (price === 0.01) {
		const priceContainer = product.querySelector('.price-final')
		if (priceContainer) {
			priceContainer.innerHTML = '<strong>Cena na dotaz</strong>'
			priceContainer.classList.add('hide-after')
		}

		const cartForm = addToCartWrapper.querySelector('.pr-action')
		if (cartForm) {
			cartForm.style.display = 'none'
		}

		if (!addToCartWrapper.querySelector('.contact-product')) {
			const productLink = product.querySelector('a.name')
			if (productLink) {
				const productUrl = productLink.getAttribute('href').replace(/\/$/, '')
				const contactDiv = document.createElement('div')
				contactDiv.classList.add('p-tools')
				contactDiv.innerHTML = `
      <a href="${productUrl}" class="btn btn-primary contact-product" aria-hidden="true" tabindex="-1">
        Detail
      </a>
    `
				addToCartWrapper.appendChild(contactDiv)
			}
		}
	}
}

const handleProducts = (blockProducts = null) => {
	!blockProducts
		? (blockProducts = document.querySelectorAll('.products-block.products .product'))
		: (blockProducts = blockProducts.querySelectorAll('.product'))
	if (blockProducts.length) {
		blockProducts.forEach((product) => {
			const haveQuantity = product.querySelector('.quantity')
			if (!haveQuantity) {
				const formerInput = product.querySelector('.pr-action input[type="hidden"][name="amount"]')
				if (formerInput) formerInput.remove()
				const addToCartBlock = product.querySelector('.p-tools .pr-action')
				if (addToCartBlock) addToCartBlock.prepend(createQuantity())
			}
			handleFlags(product)
			// handlePriceStandard(product);
			handleProductAvailability(product)
			handleProductMoreButton(product)
			handleOnDemandProducts(product)
		})
	}
}
handleProducts()
document.addEventListener('ShoptetDOMContentLoaded', () => {
	handleProducts()
})

const popularCategorySlider = document.querySelector('.popular-category')

const initPopularCategorySlider = () => {
	if (!popularCategorySlider) return
	console.log('initPopularCategorySlider')
	if (window.innerWidth >= 768) {
		if (!$(popularCategorySlider).hasClass('slick-initialized')) {
			$(popularCategorySlider).slick({
				infinite: false,
				slidesToShow: 6,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4,
						},
					},
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 3,
						},
					},
				],
			})
		}
	} else {
		if ($(popularCategorySlider).hasClass('slick-initialized')) {
			$(popularCategorySlider).slick('unslick')
		}
	}
}

const handlePopularCategory = () => {
	console.log('handlePopularCategory')
	const popularCategoryBanner = document.querySelector('.custom-footer__banner15 ')
	if (popularCategoryBanner) {
		const container = document.querySelector('#products-3')
		if (container) container.after(popularCategoryBanner)
	}
}

if (dataLayer[0]?.shoptet?.pageType === 'homepage') {
	initPopularCategorySlider()
	//   window.addEventListener("resize", initPopularCategorySlider);
	handlePopularCategory()
}

// const addButtonToProducts = () => {
//   const products = document.querySelector("#products-3");
//   if (products) {
//     const showAllButton = document.querySelector(
//       ".homepage-products-3 + .btn-show-all"
//     );
//     if (!showAllButton) {
//       const showAllButtonWrapper = document.createElement("div");
//       showAllButtonWrapper.classList.add(
//         "buttons-wrapper",
//         "buttons-center",
//         "btn-show-all"
//       );
//       const showAllButtonEl = document.createElement("a");
//       showAllButtonEl.classList.add("btn", "btn-secondary");
//       showAllButtonEl.href = btnProductsHref;
//       showAllButtonEl.innerHTML = "Zjistit více";
//       showAllButtonWrapper.appendChild(showAllButtonEl);
//       products.after(showAllButtonWrapper);
//     }
//   }
// };

// if (
//   dataLayer[0]?.shoptet?.pageType === "homepage" &&
//   typeof btnProductsHref !== "undefined"
// ) {
//   addButtonToProducts();
// }
const addButtonToAllProducts = () => {
	const productBlocks = document.querySelectorAll('.products-block')

	productBlocks.forEach((products, index) => {
		const showAllButton = products.nextElementSibling?.classList.contains('btn-show-all')

		if (!showAllButton) {
			const showAllButtonWrapper = document.createElement('div')
			showAllButtonWrapper.classList.add('buttons-wrapper', 'buttons-center', 'btn-show-all')

			const showAllButtonEl = document.createElement('a')
			showAllButtonEl.classList.add('btn', 'btn-secondary')

			showAllButtonEl.href = btnProductsHrefs[index] || '#'
			showAllButtonEl.innerHTML = 'Zjistit více'

			showAllButtonWrapper.appendChild(showAllButtonEl)
			products.after(showAllButtonWrapper)
		}
	})
}

if (dataLayer[0]?.shoptet?.pageType === 'homepage' && Array.isArray(btnProductsHrefs)) {
	addButtonToAllProducts()
}
// BLOG ON HOMEPAGE
const fetchBlogPosts = async (url) => {
	const BlogURL = url || '/blog/'
	const response = await fetch(BlogURL)
	const data = await response.text()
	const parser = new DOMParser()
	const htmlDocument = parser.parseFromString(data, 'text/html')
	const blogPosts = htmlDocument.querySelectorAll('.news-item')
	if (!blogPosts.length) return []

	const finalArray = []
	for (let i = 0; i < 4; i++) {
		if (blogPosts[i]) {
			const blogImage = blogPosts[i].querySelector('.image img')
			if (blogImage) {
				const blogImageSrc = blogImage.getAttribute('data-src')
				if (blogImageSrc) blogImage.src = blogImageSrc
			}
			finalArray.push(blogPosts[i])
		}
	}
	return finalArray
}

const handleBlogPost = (post) => {
	const postTime = post.querySelector('time')
	const postText = post.querySelector('.text')
	if (postTime && postText) {
		postText.prepend(postTime)
	}
	let readMore = post.querySelector('.title').cloneNode()
	readMore.classList.remove('title')
	readMore.classList.add('btn-read-more')
	readMore.innerText = 'Přečíst článek'
	post.querySelector('.text').appendChild(readMore)

	if (!post.querySelector('.blog-flag')) {
		const linkEl = post.querySelector('a.title')
		if (linkEl) {
			const href = linkEl.getAttribute('href')

			const segments = href.split('/').filter(Boolean)
			let subcategoryPath = '/' + (segments[0] || 'blog') + '/'
			const existingFlag = post.querySelector('.description .flag')
			if (existingFlag) {
				existingFlag.href = subcategoryPath

				existingFlag.classList.add('blog-flag', 'news-flag')

				postText.prepend(existingFlag)
			}

			//   const subcategoryName = segments[0]
			//     ? segments[0]
			//         .replace(/-/g, " ")
			//         .replace(/\b\w/g, (l) => l.toUpperCase())
			//     : "Blog";

			//   const blogFlag = document.createElement("a");
			//   blogFlag.classList.add("blog-flag", "news-flag");
			//   blogFlag.href = subcategoryPath;
			//   blogFlag.innerHTML = subcategoryName;

			//   post.querySelector(".text").prepend(blogFlag);
		}
	}
}

window.mmHandleBlogPost = handleBlogPost

document.querySelectorAll('.news-item').forEach((post) => {
	handleBlogPost(post)
})

if (dataLayer[0]?.shoptet?.pageType === 'homepage') {
	;(async () => {
		const blogWrapper = document.createElement('div')
		blogWrapper.classList.add('blog-wrapper', 'container')

		const blogPostsWrapper = document.createElement('div')
		blogPostsWrapper.id = 'newsWrapper'

		// Nadpis
		const blogHeadingEl = document.createElement('h2')
		blogHeadingEl.classList.add('homepage-group-title', 'blog-title')
		blogHeadingEl.innerHTML = typeof blogNadpis !== 'undefined' ? blogNadpis : ''
		blogWrapper.appendChild(blogHeadingEl)

		blogWrapper.appendChild(blogPostsWrapper)

		const whereToInsert = document.querySelector('.homepage-box.welcome-wrapper') || document.querySelector('.category-content-wrapper')

		if (whereToInsert && whereToInsert.parentElement) {
			whereToInsert.parentElement.insertBefore(blogWrapper, whereToInsert)
		}

		let postsFromCache = false
		if (sessionStorage.getItem('blogPosts')) {
			blogPostsWrapper.innerHTML = sessionStorage.getItem('blogPosts')
			blogPostsWrapper.querySelectorAll('.news-item').forEach((post) => {
				handleBlogPost(post)
			})
			postsFromCache = true
		} else {
			const blogPosts = await fetchBlogPosts('/blog/')
			blogPosts.forEach((post) => {
				handleBlogPost(post)
				blogPostsWrapper.appendChild(post)
			})
			// sessionStorage.setItem("blogPosts", blogPostsWrapper.innerHTML);
		}

		const toBlogButtonWrapper = document.createElement('div')
		toBlogButtonWrapper.classList.add('buttons-wrapper', 'buttons-center')

		const toBlogButton = document.createElement('a')
		toBlogButton.classList.add('btn', 'btn-secondary')
		toBlogButton.href = '/blog/'
		toBlogButton.innerHTML = window.mmLanguage === 'sk' ? 'Zobraziť blog' : 'Zobrazit blog'

		toBlogButtonWrapper.appendChild(toBlogButton)

		blogWrapper.appendChild(toBlogButtonWrapper)

		const initBlogSlider = () => {
			if (window.innerWidth < 768) {
				if (!$(blogPostsWrapper).hasClass('slick-initialized')) {
					$(blogPostsWrapper).slick({
						infinite: false,
						slidesToShow: 1.2,
						slidesToScroll: 1,
						dots: true,
						arrows: false,
					})
				}
			} else {
				if ($(blogPostsWrapper).hasClass('slick-initialized')) {
					$(blogPostsWrapper).slick('unslick')
				}
			}
		}

		initBlogSlider()
		window.addEventListener('resize', initBlogSlider)
	})()
}

// FOOTER-BOTTOM
const footerBottom = document.querySelector('.footer-bottom')
const footerGlobal = document.querySelector('#footer')
if (footerBottom && footerGlobal) {
	let footerBottomWrapper = document.querySelector('.footer-bottom-wrapper')

	if (!footerBottomWrapper) {
		footerBottomWrapper = document.createElement('div')
		footerBottomWrapper.classList.add('footer-bottom-wrapper')
		footerBottomWrapper.appendChild(footerBottom)
		footerGlobal.parentElement.insertBefore(footerBottomWrapper, footerGlobal.nextElementSibling)
	}

	const signature = footerBottom.querySelector('#signature')
	if (signature) {
		signature.style.display = 'flex'
	}
}

if (footerGlobal) {
	const footerLinks = footerGlobal.querySelector('.footer-links-icons')
	const topNavigationContacts = document.querySelector('.top-navigation-contacts')
	const footerSiteName = footerGlobal.querySelector('.site-name')

	if (footerLinks) {
		const existingTopContacts = footerLinks.querySelector('.top-navigation-contacts')

		if (topNavigationContacts && !existingTopContacts) {
			const topNavigationContactsClone = topNavigationContacts.cloneNode(true)

			if (window.innerWidth > 767) {
				footerLinks.prepend(topNavigationContactsClone)
			} else {
				const newsletter = document.querySelector('.custom-footer__newsletter')
				if (newsletter) {
					newsletter.before(topNavigationContactsClone)
				}
			}
		}

		if (footerSiteName) {
			footerLinks.prepend(footerSiteName)
		}
	}
}

const newsletter = document.querySelector('.custom-footer__newsletter')
if (newsletter) {
	const newsletterHeader = document.querySelector('.newsletter-header')
	if (newsletterHeader) newsletterHeader.innerHTML = `<h4>Newsletter</h4><p>${newsletterTexts}</p>`
	const newsletterBtn = newsletter.querySelector('.btn.btn-primary')
	const newsletterInput = newsletter.querySelector('.form-group:has(.form-control-wrapper #newsletterWidget)')
	const emailInput = newsletter.querySelector('#newsletterWidget')
	if (newsletterBtn && newsletterInput) {
		newsletterBtn.innerHTML = 'Odebírat'
		newsletterInput.appendChild(newsletterBtn)
	}
	if (emailInput) {
		emailInput.setAttribute('placeholder', 'E-mail')
	}
}

// PRODUCT DETAIL
const createShpTabLink = (text, anchor) => {
	const shpTabLi = document.createElement('li')
	const shpTabLink = document.createElement('a')
	shpTabLi.classList.add('shp-tab')
	shpTabLi.appendChild(shpTabLink)
	shpTabLink.classList.add('shp-tab-link')
	shpTabLink.href = anchor
	shpTabLink.innerHTML = text
	return shpTabLi
}
if (document.body.classList.contains('type-detail')) {
	const pDetailTabs = document.querySelector('#p-detail-tabs')
	const tabContent = document.querySelector('#tab-content')

	const customMobileSlider = document.querySelector('.custom-slider-wrapper')
	if (customMobileSlider)
		$(customMobileSlider).slick({
			infinite: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
		})

	// DLOUHY POPIS + OSTATNI TABY
	const shpTabLinks = document.querySelectorAll('.shp-tab-link')
	if (shpTabLinks.length) {
		shpTabLinks.forEach((link) => {
			link.removeAttribute('role')
			link.removeAttribute('data-toggle')
		})
	}
	const parametersTabContent = document.querySelector('#description .extended-description:not(.custom)')
	const descriptionTab = document.querySelector('.shp-tab[data-testid="tabDescription"]')

	//   if (parametersTabContent && descriptionTab) {
	//     if (window.innerWidth <= 767) {
	//       // const parametersTab = createShpTabLink('Specifikace', '#parameters')
	//       const parametersTab = descriptionTab.cloneNode(true);
	//       parametersTab.classList.remove("active");
	//       descriptionTab.after(parametersTab);
	//       // parametersTabContent.id = 'parameters'
	//       const parametersLink = parametersTab.querySelector(".shp-tab-link");
	//       parametersLink.innerText = "Specifikace";
	//       parametersLink.href = "#parameters";
	//       const description = document.querySelector("#description");
	//       if (description) {
	//         const descClone = description.cloneNode(true);
	//         description.after(descClone);
	//         descClone.id = "parameters";
	//         descClone.classList.remove("active");
	//         const paramInDesc = description.querySelector(".extended-description");
	//         const descInParam = descClone.querySelector(".basic-description");
	//         if (paramInDesc) paramInDesc.remove();
	//         if (descInParam) descInParam.remove();
	//       }
	//     } else {
	//       // const descriptionLink = descriptionTab.querySelector(".shp-tab-link");
	//       // if (descriptionLink) descriptionLink.innerText = "Popis a specifikace";
	//     }
	//   }

	//   // const ratingTab = document.querySelector('#ratingTab')
	//   // if (ratingTab) {
	//   // 	const ratingTabHeading = document.createElement('h3')
	//   // 	ratingTabHeading.innerHTML = 'Hodnocení'
	//   // 	ratingTab.prepend(ratingTabHeading)
	//   // }
	const discussionTab = document.querySelector('#productDiscussion')
	if (discussionTab) {
		const discussionHeading = document.createElement('h3')
		discussionHeading.innerHTML = 'Diskuze'
		discussionTab.prepend(discussionHeading)
	}
	const alternativeProductsTabLink = document.querySelector('.shp-tab-link[href="#productsAlternative"]')
	// if (alternativeProductsTabLink)
	// alternativeProductsTabLink.parentElement.remove();
	const alternativeProducts = document.querySelector('#productsAlternative')
	if (alternativeProducts) {
		const alternativeProductsHeading = document.createElement('h3')
		alternativeProducts.classList.remove('tab-pane')
		// if (!document.body.classList.contains("discontinued-product")) {
		alternativeProductsHeading.innerHTML = 'Podobné produkty'
		// const helpUSP = document.querySelector('#content > .benefitBanner')
		// if (helpUSP) {
		// 	helpUSP.parentElement.insertBefore(alternativeProductsHeading, helpUSP)
		// 	helpUSP.parentElement.insertBefore(alternativeProducts, helpUSP)
		// } else {
		// }
		// } else {
		//   alternativeProductsHeading.innerHTML = "Alternativy k produktu";
		//   const pDetailInner = document.querySelector(".p-detail-inner");
		//   pDetailInner.parentElement.insertBefore(
		//     alternativeProducts,
		//     pDetailInner.nextElementSibling
		//   );
		//   pDetailInner.parentElement.insertBefore(
		//     alternativeProductsHeading,
		//     pDetailInner.nextElementSibling
		//   );
		//   const toAlternatives = document.createElement("a");
		//   toAlternatives.classList.add("btn", "btn-primary");
		//   toAlternatives.href = "#productsAlternative";
		//   toAlternatives.innerHTML = "Vybrat alternativu";
		//   const pInfoWrapper = document.querySelector(".p-info-wrapper");
		//   if (pInfoWrapper) pInfoWrapper.appendChild(toAlternatives);
		// }
		if (!alternativeProducts.classList.contains('slick-initialized')) {
			$(alternativeProducts.querySelector('.products-block')).slick(window.productsSlickSettings)
		}
		// const productDiscussion = document.querySelector('#productDiscussion')
		// if (productDiscussion) {
		// 	productDiscussion.before(alternativeProductsHeading)
		// 	productDiscussion.before(alternativeProducts)
		// }
		const pDetailtabsWrapper = document.querySelector('.p-detail-tabs-wrapper')
		if (pDetailtabsWrapper) {
			pDetailtabsWrapper.parentElement.insertBefore(alternativeProducts, pDetailtabsWrapper.nextElementSibling)
			pDetailtabsWrapper.parentElement.insertBefore(alternativeProductsHeading, pDetailtabsWrapper.nextElementSibling)
		}
	}

	const relatedProducts = document.querySelector('.products-related')
	const relatedProductsHeading = document.querySelector('.products-related-header')
	if (relatedProducts && relatedProductsHeading) {
		// relatedProductsHeading.classList.add("homepage-group-title");

		if (!relatedProducts.classList.contains('slick-initialized')) {
			$(relatedProducts).slick(window.productsSlickSettings)
		}

		const pDetailtabsWrapper = document.querySelector('.p-detail-tabs-wrapper')
		if (pDetailtabsWrapper) {
			pDetailtabsWrapper.parentElement.insertBefore(relatedProducts, pDetailtabsWrapper.nextElementSibling)
			pDetailtabsWrapper.parentElement.insertBefore(relatedProductsHeading, pDetailtabsWrapper.nextElementSibling)
		}

		// const productDiscussion = document.querySelector("#productDiscussion");
		// if (productDiscussion) {
		//   productDiscussion.before(relatedProductsHeading);

		//   productDiscussion.before(relatedProducts);
		// }
	}

	//   if (document.body.classList.contains("discontinued-product")) {
	//     const firstCategory = document.querySelector(
	//       ".breadcrumbs #navigation-1 a"
	//     );
	//     if (firstCategory) {
	//       const firstCategoryMenu = document.querySelector(
	//         '.menu-level-1 > li > a[href="' +
	//           firstCategory.getAttribute("href") +
	//           '"]'
	//       );
	//       if (firstCategoryMenu) {
	//         const menuToCopy = firstCategoryMenu
	//           .closest("li")
	//           .querySelector(".menu-level-2");
	//         const productsAlternative =
	//           document.querySelector("#productsAlternative") ||
	//           document.querySelector(".p-detail-inner");
	//         // if (menuToCopy && productsAlternative) {
	//         //   const menuClone = menuToCopy.cloneNode(true);
	//         //   menuClone.classList.remove("menu-level-2");
	//         //   menuClone.classList.add("alternative-categories");
	//         //   productsAlternative.parentElement.insertBefore(
	//         //     menuClone,
	//         //     productsAlternative.nextElementSibling
	//         //   );
	//         //   if (typeof kategorie404Nadpis != "undefined") {
	//         //     const menuTitle = document.createElement("h2");
	//         //     menuTitle.classList.add("homepage-group-title");
	//         //     menuTitle.innerHTML = kategorie404Nadpis;
	//         //     menuClone.parentElement.insertBefore(menuTitle, menuClone);
	//         //   }
	//         //   if (typeof kategorie404Perex != "undefined") {
	//         //     const menuPerex = document.createElement("p");
	//         //     menuPerex.innerHTML = kategorie404Perex;
	//         //     menuClone.parentElement.insertBefore(menuPerex, menuClone);
	//         //   }
	//         // }
	//       }
	//     }
	//   }
}

// CART
function handleCart() {
	const pageHeader = document.querySelector('#header')
	const cartHeader = document.querySelector('.cart-content .cart-header')
	const cartHeaderHelper = document.querySelector('.cart-header-wrapper')
	if (cartHeader && !cartHeaderHelper) {
		const cartHeaderWrapper = document.createElement('div')
		cartHeaderWrapper.classList.add('cart-header-wrapper')
		cartHeaderWrapper.appendChild(cartHeader)
		cartHeader.classList.add('container')
		pageHeader.parentElement.insertBefore(cartHeaderWrapper, pageHeader.nextElementSibling)
	} else if (cartHeader) {
		cartHeader.remove()
	}

	if (typeof kosikKontakt !== 'undefined' && !document.querySelector('#header .cart-contact')) {
		const cartContact = document.createElement('div')
		cartContact.innerHTML = kosikKontakt
		const siteNameWrapper = document.querySelector('.site-name-wrapper')
		siteNameWrapper.parentElement.insertBefore(cartContact, siteNameWrapper.nextElementSibling)
	}

	const sidebarCart = document.querySelector('.sidebar-in-cart')
	const summaryWrapper = document.querySelector('.summary-wrapper')
	// const sidebarCart = document.querySelector('.sidebar-in-cart .box[data-testid="tableCart"]')
	const discountForm = document.querySelector('.discount-coupon')
	if (discountForm && summaryWrapper) {
		if (window.innerWidth > 767) {
			summaryWrapper.append(discountForm)
		} else {
			const container = summaryWrapper.querySelector('.box')
			container.prepend(discountForm)
		}
		const discountInput = discountForm.querySelector('input')
		discountInput.placeholder = 'Slevový kód'
	}

	const extraDelivery = document.querySelector('.extra.delivery')
	if (extraDelivery && sidebarCart) {
		if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0) extraDelivery.classList.add('free-shipping')
		summaryWrapper.append(extraDelivery)
		// sidebarCart.prepend(extraDelivery)
	}

	const overallWrapper = document.querySelector('.overall-wrapper')
	const cartFooter = document.createElement('div')
	cartFooter.classList.add('cart-footer')
	if (overallWrapper) overallWrapper.appendChild(cartFooter)
	const cartMail = document.querySelector('.contact-box .mail')
	const cartPhone = document.querySelector('.contact-box .tel')

	const sidebarNextStep = document.querySelector('#checkoutSidebar .next-step')
	const orderSummary = document.querySelector('#summary-box')
	// if (sidebarNextStep && orderSummary) orderSummary.appendChild(sidebarNextStep)

	const sidebarConsents = document.querySelectorAll('#checkoutSidebar .consents')
	const summaryItemPrice = document.querySelector('#checkoutSidebar .order-summary-item.price')
	// if (sidebarConsents.length && summaryItemPrice) {
	// 	sidebarConsents.forEach((consent) => {
	// 		summaryItemPrice.parentElement.insertBefore(consent, summaryItemPrice.nextElementSibling)
	// 	})
	// }

	// const backToShopButtons = document.querySelectorAll('.back-to-shop')
	// if (backToShopButtons.length) {
	// 	backToShopButtons.forEach((button) => {
	// 		button.innerText = 'Zpět do obchodu'
	// 	})
	// }
	const paymentInfoTooltips = document.querySelectorAll('.payment-info .show-tooltip')
	if (paymentInfoTooltips.length) {
		paymentInfoTooltips.forEach((tooltip) => {
			tooltip.innerText = 'i'
		})
	}
	const handleFreeRecapitulation = () => {
		setTimeout(() => {
			const recapItemPrices = document.querySelectorAll('.recapitulation-shipping-billing-info > span')
			if (recapItemPrices.length) {
				recapItemPrices.forEach((price) => {
					if (price.innerText.toUpperCase().includes('ZDARMA')) {
						price.classList.add('for-free')
					} else {
						price.classList.remove('for-free')
					}
				})
			}
		}, 100)
	}
	document.addEventListener('ShoptetShippingMethodUpdated', handleFreeRecapitulation)
	document.addEventListener('ShoptetBillingMethodUpdated', handleFreeRecapitulation)

	const recapItemPrices = document.querySelectorAll('span[data-testid="recapItemPrice"]')
	if (recapItemPrices.length) {
		recapItemPrices.forEach((price) => {
			if (price.innerText.toUpperCase().includes('ZDARMA')) {
				price.classList.add('for-free')
			} else {
				price.classList.remove('for-free')
			}
		})
	}

	// const continueOrderButton = document.querySelector('#orderFormButton') || document.querySelector('#continue-order-button')
	// if (continueOrderButton) {
	// 	continueOrderButton.innerText = 'Pokračovat v objednávce'
	// }
	const relatedProductsBuyButton = document.querySelectorAll('.cart-related-product .add-to-cart-button')
	if (relatedProductsBuyButton.length) {
		relatedProductsBuyButton.forEach((button) => {
			button.innerText = 'Koupit'
		})
	}

	const footerCheck = document.querySelector('.ordering-process-footer')
	if (!footerCheck) {
		const cartProjectMail = document.querySelector('.contact-box .mail')
		const cartProjectPhone = document.querySelector('.contact-box .tel')
		const orderingProcessFooter = document.createElement('footer')
		orderingProcessFooter.classList.add('ordering-process-footer')
		orderingProcessFooter.innerHTML = `
			<div class="container">
				<div class="secure-payment">
					<span>Bezpečná platba</span>
					<img src="/user/documents/upload/miranda/platebni_metody.png" width="286" height="23" alt="Visa, MasterCard, Maestro, PayPal"/>
				</div>
				<div class="contact-box phone-wrapper">
					<span>${typeof callCenterHours != null ? callCenterHours : 'Po–Pá: 9:00–18:30'}</span>
				</div>
				<div class="contact-box mail-wrapper">
					<span>Reagujeme do 24 hodin</span>
				</div>
			</div>
		`
		overallWrapper.appendChild(orderingProcessFooter)
		const orderingProcessFooterPhoneWrapper = orderingProcessFooter.querySelector('.phone-wrapper')
		const orderingProcessFooterMailWrapper = orderingProcessFooter.querySelector('.mail-wrapper')
		if (cartProjectPhone) {
			orderingProcessFooterPhoneWrapper.prepend(cartProjectPhone.cloneNode(true))
			orderingProcessFooter.querySelector('.phone-wrapper .tel').classList.add('project-phone')
		}
		if (cartProjectMail) {
			orderingProcessFooterMailWrapper.prepend(cartProjectMail.cloneNode(true))
			orderingProcessFooter.querySelector('.mail-wrapper .mail a').classList.add('project-email')
		}
	}
	const nextStepBack = document.querySelector('.next-step-back')
	const cartInner = document.querySelector('.cart-inner')
	// if cart inner has nextStepBack, move nextStepBack after cartInner
	if (nextStepBack && cartInner && cartInner.contains(nextStepBack)) {
		cartInner.insertAdjacentElement('afterend', nextStepBack)
	}

	if (dataLayer[0].shoptet.pageType === 'cart') {
		;(async () => {
			try {
				const response = await fetch('/objednavka/krok-1/')
				const data = await response.text()
				const parser = new DOMParser()
				const htmlDocument = parser.parseFromString(data, 'text/html')
				const cartMessage = htmlDocument.querySelector('.site-msg-custom')
				if (cartMessage) {
					const cartSummary = document.querySelector('.summary-wrapper .box[data-testid="tableCart"]')
					if (cartSummary) cartSummary.parentElement.insertBefore(cartMessage, cartSummary)
				}
			} catch (error) {
				console.error(error)
			}
		})()
	}

	// const newsletterCheckbox = document.querySelector("#sendNewsletter");
	// if (newsletterCheckbox && summaryItemPrice)
	//   summaryItemPrice.parentElement.insertBefore(
	//     newsletterCheckbox.closest(".form-group"),
	//     summaryItemPrice.nextElementSibling
	//   );
	const cartContent = document.querySelector('.cart-content')
	const cartObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.classList.contains('mehub-bonus-cart-container')) {
					sidebarCart.appendChild(node)
				}
			})
		})
	})
	if (cartContent) cartObserver.observe(cartContent, { childList: true })
	if (window.innerWidth < 768) {
		const productsInCart = document.querySelectorAll('.cart-table tr.removeable[data-micro="cartItem"]')
		productsInCart.forEach((product) => {
			const showRelated = product.querySelector('.show-related')
			if (showRelated) {
				product.appendChild(showRelated)
			}
			// 		const productSKU = product.getAttribute('data-micro-sku')
			// 		const productName = product.querySelector('.p-name')
			// 		if (productSKU && productName) {
			// 			const productSKUEl = document.createElement('div')
			// 			productSKUEl.classList.add('product-sku')
			// 			productSKUEl.innerHTML = `Kód: ${productSKU}`
			// 			productName.appendChild(productSKUEl)
			// 		}
		})
	}
	const regBlock = document.querySelector('#set-registration')?.closest('.form-group')
	const consentsBlock = document.querySelector('.form-group.js-validated-element-wrapper.consents.consents-first')

	if (regBlock && consentsBlock) {
		consentsBlock.after(regBlock)
	}
}
if (document.body.classList.contains('ordering-process')) {
	handleCart()
	document.addEventListener('ShoptetDOMCartContentLoaded', handleCart)
}

// POPUP CART
document.addEventListener('ShoptetDOMCartContentLoaded', () => {
	const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol
	const cartWidgetProducts = document.querySelectorAll('.cart-widget-product')
	if (cartWidgetProducts.length) {
		cartWidgetProducts.forEach((product) => {
			const productPrice = product.querySelector('span[data-testid="cartWidgetProductPrice"]')
			if (productPrice) {
				const priceEl = document.createElement('div')
				priceEl.classList.add('cart-widget-product-price')
				priceEl.appendChild(productPrice)
				product.appendChild(priceEl)
				const productSKU = product.getAttribute('data-micro-sku')
				// if (productSKU) {
				// 	const productSinglePrice = dataLayer[0].shoptet.cart.filter((item) => item.code === productSKU)[0].priceWithVat
				// 	const productSinglePriceEl = document.createElement('div')
				// 	productSinglePriceEl.classList.add('cart-widget-product-single-price')
				// 	productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks`
				// 	priceEl.appendChild(productSinglePriceEl)
				// }
			}
		})
	}

	let popupCartSummary = document.querySelector('.popup-cart-summary')
	if (!popupCartSummary) {
		popupCartSummary = document.createElement('div')
		popupCartSummary.classList.add('popup-cart-summary')
	}
	const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
	const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
	// popupCartSummary.innerHTML = `
	// 	<div class="popup-cart-summary-item">
	// 		<strong class="popup-cart-summary-item-label">Celkem</strong>
	// 		<strong class="popup-cart-summary-item-value">${Number(popupCartSummaryPriveVAT).toLocaleString('cs-CZ')} ${currencyLabel}</strong>
	// 	</div>
	// 	`
	// <div class="popup-cart-summary-item">
	// 	<span class="popup-cart-summary-item-label">Celkem bez DPH</span>
	// 	<span class="popup-cart-summary-item-value">${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}</span>
	// </div>
	const cartWidgetProductsWrapper = document.querySelector('.cart-widget-products')
	if (cartWidgetProductsWrapper)
		cartWidgetProductsWrapper.parentElement.insertBefore(popupCartSummary, cartWidgetProductsWrapper.nextElementSibling)

	const cartWidgetButton = document.querySelector('.cart-widget-button')
	const cartWidgetInner = document.querySelector('.cart-widget-inner')
	if (cartWidgetButton && cartWidgetInner) cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true))

	const cartWidgetShipping = document.querySelector('.cart-free-shipping')
	if (cartWidgetShipping) {
		const priceLeftToFreeShipping = dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft
		if (priceLeftToFreeShipping > 0) {
			const freeShippingBar = document.createElement('div')
			const freeShippingValue = document.createElement('div')
			freeShippingBar.classList.add('price-range')
			freeShippingBar.appendChild(freeShippingValue)
			freeShippingValue.style.width = `${100 - (100 * priceLeftToFreeShipping) / (priceLeftToFreeShipping + popupCartSummaryPriveVAT)}%`
			cartWidgetShipping.appendChild(freeShippingBar)
			const shippingWidgetStrongs = cartWidgetShipping.querySelectorAll('strong')
			if (shippingWidgetStrongs.length) {
				shippingWidgetStrongs.forEach((strong) => {
					if (strong.innerText.includes('ZDARMA')) strong.classList.add('free-shipping-strong')
				})
			}
		}
	}
})
// document.addEventListener('ShoptetCartUpdated', () => {
// 	const popupCartSummary = document.querySelector('.popup-cart-summary')
// 	console.log(popupCartSummary)
// 	// const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
// 	// const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
// 	// const popupCartPriceVAT = popupCartSummary.querySelector('strong.popup-cart-summary-item-value')
// 	// const popupCartPriceNoVAT = popupCartSummary.querySelector('span.popup-cart-summary-item-value')
// 	// popupCartPriceVAT.innerHTML = `${popupCartSummaryPriveVAT} ${currencyLabel}`
// 	// popupCartPriceNoVAT.innerHTML = `${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}`
// })

// ADVANCED ORDER
document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
	const advancedOrder = document.querySelector('.advanced-order')
	const aoTop = document.createElement('div')
	aoTop.classList.add('ao-top')
	advancedOrder.prepend(aoTop)
	const aoTitle = advancedOrder.querySelector('.h1')
	if (aoTitle) aoTop.appendChild(aoTitle)
	const aoProduct = advancedOrder.querySelector('.ao-product') || advancedOrder.querySelector('.h2')
	if (aoProduct) aoTop.appendChild(aoProduct)
	const cboxClose = document.querySelector('#cboxClose')
	if (cboxClose) {
		cboxClose.innerText = 'Zavřít'
		// aoTop.appendChild(cboxClose)
	}
	const continueShoppingBtn = document.createElement('button')
	continueShoppingBtn.classList.add('btn-continue-shopping')
	continueShoppingBtn.innerText = 'Pokračovat v nákupu'
	continueShoppingBtn.addEventListener('click', () => {
		shoptet.modal.close()
	})
	const extraStep = advancedOrder.querySelector('.extra.step')
	if (extraStep) extraStep.prepend(continueShoppingBtn)

	const deliveryStrongs = advancedOrder.querySelectorAll('.extra.delivery strong')
	if (deliveryStrongs.length) {
		deliveryStrongs.forEach((strong) => {
			if (strong.innerText === 'ZDARMA') strong.classList.add('for-free')
		})
	}
	const suggestionsTitle = advancedOrder.querySelector('.advanced-order-suggestion')
	if (suggestionsTitle) suggestionsTitle.innerHTML = 'Doporučené příslušenství'
})

// EMPTY CART

const handleEmptyCart = () => {
	const emptyCart = document.querySelector('.cart-inner.cart-empty')
	document.body.classList.add('custom-empty-cart')
	const cartHeading = emptyCart?.querySelector('.cart-heading')
	const cartText = document.createElement('p')
	cartText.classList.add('narrow-custom', 'text-center')
	cartText.innerText = typeof prazdnyKosikPerex !== 'undefined' ? prazdnyKosikPerex : ''
	if (cartHeading) {
		cartHeading.innerText = typeof prazdnyKosikNadpis !== 'undefined' ? prazdnyKosikNadpis : 'Váš nákupní košík je prázný'
		cartHeading.classList.add('homepage-group-title')
		cartHeading.parentElement.insertBefore(cartText, cartHeading.nextElementSibling)
	}
	// const cartEmail = emptyCart.querySelector('.mail')
	// const cartPhone = emptyCart.querySelector('.tel')
	// const cartContact = document.createElement('ul')
	// cartContact.classList.add('cart-contact', 'contact-box')
	// if (cartPhone) {
	// 	if (typeof headerOpeningHours !== 'undefined') {
	// 		const phonePerex = document.createElement('span')
	// 		phonePerex.innerText = headerOpeningHours
	// 		cartPhone.parentElement.insertBefore(phonePerex, cartPhone.nextElementSibling)
	// 	}
	// 	cartContact.appendChild(cartPhone.parentElement)
	// }
	// if (cartEmail) {
	// 	const emailPerex = document.createElement('span')
	// 	emailPerex.innerText = 'Odpovídáme do 24 hodin'
	// 	cartEmail.parentElement.insertBefore(emailPerex, cartEmail.nextElementSibling)
	// 	cartContact.appendChild(cartEmail.parentElement)
	// }
	// emptyCart.appendChild(cartContact)
	const backToShopButton = document.createElement('div')
	backToShopButton.classList.add('buttons-wrapper', 'buttons-center')
	backToShopButton.innerHTML = `
		<a href="/" class="btn btn-primary btn-lg">Zpět do obchodu</a>
	`
	emptyCart?.appendChild(backToShopButton)
	const emptyCartHeader = document.querySelector('.cart-header-wrapper')
	if (emptyCartHeader) emptyCartHeader.remove()
}
const emptyCart = document.querySelector('.cart-inner.cart-empty')
// if (emptyCart) handleEmptyCart();

document.addEventListener('ShoptetDOMCartContentLoaded', () => {
	if (dataLayer[0].shoptet.pageType === 'cart') {
		// handleEmptyCart();
	}
})

// EMPTY CART POPUP
// const handleEmptyCartPopup = () => {
// 	const isEmpty = document.querySelector('.cart-widget .place-cart-here')
// 	if (isEmpty) {
// 		const toggleCart = document.querySelector('.toggle-window.cart-count')
// 		if (toggleCart) {
// 			toggleCart.addEventListener('mouseenter', () => document.body.classList.add('user-action-visible', 'cart-window-visible'))
// 			// toggleCart.addEventListener('mouseleave', () => document.body.classList.remove('user-action-visible', 'cart-window-visible'))
// 		}
// 		const cartLoader = isEmpty.querySelector('.loader-overlay')
// 		if (cartLoader) cartLoader.remove()
// 		const emptyCartPopup = document.createElement('div')
// 		emptyCartPopup.classList.add('empty-cart-popup')

// 		emptyCartPopup.innerHTML = `
// 			<h2>Ve vašem košíku nemáte žádné zboží</h2>
// 			<p>Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte Majyi, která Vám s výběrem velmi ráda pomůže.</p>
// 			<div class="contact-box phone-placeholder">
// 			</div>
// 			<div class="contact-box mail-placeholder">
// 				<span>Odpovídáme do 24 hodin</span>
// 			</div>
// 			<p>Nebo přejděte na naše kategorie</p>
// 			<ul class="subcategories">
// 			</ul>
// 		`
// 		if (typeof emptyCartSubcategories !== 'undefined') {
// 			const subcategoriesWrapper = emptyCartPopup.querySelector('.subcategories')
// 			emptyCartSubcategories.forEach((subcategory) => {
// 				const subcategoryEl = document.createElement('li')
// 				subcategoryEl.innerHTML = `
// 					<a href="${subcategory.link}">
// 						<span class="text">${subcategory.text}</span>
// 						<span class="image">
// 							<img src="${subcategory.image}" alt="" />
// 						</span>
// 					</a>
// 				`
// 				subcategoriesWrapper.appendChild(subcategoryEl)
// 			})
// 		}
// 		isEmpty.appendChild(emptyCartPopup)
// 		const projectMail = document.querySelector('.contact-box .mail')
// 		const projectPhone = document.querySelector('.contact-box .tel')
// 		const phonePlaceholder = emptyCartPopup.querySelector('.phone-placeholder')
// 		const mailPlaceholder = emptyCartPopup.querySelector('.mail-placeholder')
// 		if (projectPhone) {
// 			phonePlaceholder.appendChild(projectPhone.cloneNode(true))
// 			// if (headerOpeningHours) {
// 			// 	const phonePerex = document.createElement('span')
// 			// 	phonePerex.innerText = headerOpeningHours
// 			// 	phonePlaceholder.appendChild(phonePerex)
// 			// }
// 		}
// 		if (projectMail) {
// 			mailPlaceholder.prepend(projectMail.cloneNode(true))
// 		}
// 	}
// }
// handleEmptyCartPopup()

const handleFilterEvents = () => {
	// const filtersBoolean = document.querySelector('.filter-section-boolean')
	// if (filtersBoolean) {
	// 	const help = filtersBoolean.querySelector('h4')
	// 	if (!help) {
	// 		const filtersBooleanHeading = document.createElement('h4')
	// 		filtersBooleanHeading.innerHTML = 'Štítky'
	// 		filtersBoolean.prepend(filtersBooleanHeading)
	// 	}
	// }
	const filterSection = document.querySelectorAll('.filter-section')
	if (filterSection.length) {
		filterSection.forEach((section) => {
			let heading = section.querySelector('h4')
			if (heading) {
				heading.addEventListener('click', (e) => {
					e.preventDefault()
					e.stopPropagation()
					section.classList.toggle('filter-form-visible')
					let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
						parentClass = e.currentTarget.parentElement.className
					parentClass = parentClass.replace('filter-form-visible', '')
					parentClass = parentClass.trim()
					if (cache.includes(parentClass)) {
						cache = cache.filter((item) => {
							return item !== parentClass
						})
					} else {
						cache.push(parentClass)
					}
					window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
				})
			}
			const filtersCount = section.querySelectorAll('.filter-label')
			if (filtersCount.length > 7) {
				section.classList.add('hide-more')
				const showAllButton = document.createElement('button')
				showAllButton.classList.add('show-all-filters')
				showAllButton.innerText = 'Zobrazit všechny'
				showAllButton.addEventListener('click', () => {
					section.classList.toggle('hide-more')
					if (section.classList.contains('hide-more')) {
						showAllButton.innerText = 'Zobrazit všechny'
					} else {
						showAllButton.innerText = 'Skrýt'
					}
				})
				section.appendChild(showAllButton)
			}
		})
	}
	const priceFilterCustom = document.querySelector('.slider-wrapper')
	if (priceFilterCustom) {
		priceFilterCustom.querySelector('h4').addEventListener('click', (e) => {
			priceFilterCustom.classList.toggle('filter-form-visible')
			let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
				parentClass = e.currentTarget.parentElement.classList[0]
			if (cache.includes(parentClass)) {
				cache = cache.filter((item) => {
					return item !== parentClass
				})
			} else {
				cache.push(parentClass)
			}
			window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
		})
	}

	let helperCache = window.sessionStorage.getItem('openedFilters')
	if (helperCache) {
		helperCache = JSON.parse(helperCache)
		if (helperCache.length) {
			helperCache.forEach((item) => {
				item = item.replaceAll(' ', '.')
				item = document.querySelector(`.${item}`)
				if (item) item.classList.add('filter-form-visible')
			})
		}
	}

	const categoriesFilter = document.querySelector('#categories ul.active')
	if (categoriesFilter) {
		const liItems = categoriesFilter.querySelectorAll('li')
		const alreadyHasButton = categoriesFilter.parentElement.querySelector('.show-all-filters')
		if (liItems.length > 5 && !alreadyHasButton) {
			const showAllButton = document.createElement('button')
			showAllButton.classList.add('show-all-filters')
			showAllButton.innerText = 'Zobrazit všechny'
			showAllButton.addEventListener('click', () => {
				categoriesFilter.classList.toggle('show-all')
				if (categoriesFilter.classList.contains('show-all')) {
					showAllButton.innerText = 'Zobrazit všechny'
				} else {
					showAllButton.innerText = 'Skrýt'
				}
			})
			categoriesFilter.parentElement.appendChild(showAllButton)
			categoriesFilter.classList.add('show-all')
		}
	}
	const filterSections = document.querySelector('.filter-sections')

	if (filterSections) {
		const activeFilters =
			filterSections.querySelectorAll('#filters input[type="checkbox"]:checked+label') ||
			document.querySelectorAll('#filters input[type="checkbox"]:checked+label')

		if (activeFilters.length) {
			let activeFiltersWrapper = document.querySelector('.active-filters')

			if (!activeFiltersWrapper) {
				activeFiltersWrapper = document.createElement('div')
				activeFiltersWrapper.classList.add('active-filters')

				const activeFiltersInner = document.createElement('div')
				activeFiltersInner.classList.add('active-filters__inner')

				const activeFiltersList = document.createElement('div')
				activeFiltersList.classList.add('active-list')

				activeFiltersInner.appendChild(activeFiltersList)
				activeFiltersWrapper.appendChild(activeFiltersInner)

				const categoryContentWrapper = document.querySelector('.category-content-wrapper #category-header')
				if (categoryContentWrapper) {
					categoryContentWrapper.after(activeFiltersWrapper)
				}
			}

			const activeFiltersInner = activeFiltersWrapper.querySelector('.active-filters__inner')
			const activeFiltersList = activeFiltersWrapper.querySelector('.active-list')

			activeFiltersList.innerHTML = ''

			activeFilters.forEach((item) => {
				activeFiltersList.appendChild(item.cloneNode(true))
			})
			let deleteFilters = document.querySelector('#clear-filters')

			if (deleteFilters) {
				const deleteFiltersLink = deleteFilters.querySelector('a')
				if (deleteFiltersLink) {
					deleteFiltersLink.textContent = 'Zrušit vše filtry'
				}

				if (!activeFiltersInner.querySelector('#clear-filters')) {
					activeFiltersInner.appendChild(deleteFilters)
				}
			}
		} else {
			const existing = document.querySelector('.active-filters')
			if (existing) existing.remove()
		}
	}
}
if (dataLayer[0].shoptet.pageType === 'category' || document.body.classList.contains('type-manufacturer-detail')) {
	handleFilterEvents()
	document.addEventListener('ShoptetDOMContentLoaded', handleFilterEvents)
}
if (dataLayer[0].shoptet.pageType === 'category' && window.innerWidth < 768) {
	const appendFIltersWrapperToSubcategories = () => {
		const dklabFilters = document.querySelector('.dkLab-filters-wrapper')
		if (dklabFilters) {
			const subcategoriesFilterWrapper = document.querySelector('.subcategories-filter-wrapper')
			if (subcategoriesFilterWrapper) {
				subcategoriesFilterWrapper.appendChild(dklabFilters)
			}
		}
	}
	document.addEventListener('dkLabFiltersLoaded', appendFIltersWrapperToSubcategories)
	document.addEventListener('dkLabFiltersChanged', appendFIltersWrapperToSubcategories)
}
const backToTop = document.querySelector('#back-to-top')
if (backToTop) {
	backToTop.addEventListener('click', (e) => {
		e.preventDefault()
		window.scrollTo(0, 0)
	})
}

const handleFooter = async () => {
	// const socialIcons = document.querySelector('.footer-links-icons')
	// const contactBanner = document.querySelector('.custom-footer__contact')
	// if (socialIcons && contactBanner) contactBanner.appendChild(socialIcons)

	const signature = document.querySelector('#signature')
	if (signature) {
		const mirandaMediaLink = `
			<a class="company" href="https://www.mirandamedia.cz/shoptetnamiru" target="_blank">
				<img class="company__logo" src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/eretail/assets/img/miranda_logo.png">
				MirandaMedia Group s.r.o
			</a>
		`
		signature.insertAdjacentHTML('beforeend', mirandaMediaLink)
	}
	const footerHeadings = document.querySelectorAll('.banner-wrapper > span > h4')
	// footerHeadings.forEach((heading) => {
	//   heading.classList.add("clickable");
	//   heading.addEventListener("click", () => {
	//     heading.classList.toggle("active");
	//   });
	// });
	const footerCategories = document.querySelector('.custom-footer__categories > h4')
	// if (footerCategories) {
	//   footerCategories.classList.add("clickable");
	//   footerCategories.addEventListener("click", () => {
	//     footerCategories
	//       .closest(".custom-footer__categories")
	//       .classList.toggle("active");
	//   });
	// }

	const siteName = document.querySelector('#footer .site-name')
	const siteNamePlaceholder = document.querySelector('#footer .site-name-placeholder')
	if (siteName && siteNamePlaceholder) {
		siteNamePlaceholder.append(siteName)
	}
	const customFooterContact = document.querySelector('#footer .custom-footer__contact')
	const customFooterContactPlaceholder = document.querySelector('#footer .contacts-placeholder')
	if (customFooterContact && customFooterContactPlaceholder) {
		customFooterContactPlaceholder.append(customFooterContact)
	}

	let prodejnyBanner = document.querySelector('.banner-prodejny')
	if (prodejnyBanner) {
		prodejnyBanner = prodejnyBanner.closest('.banner').parentElement
		if (dataLayer[0].shoptet.pageType === 'homepage') {
			const siteFooter = document.querySelector('#footer')
			siteFooter.parentElement.insertBefore(prodejnyBanner, siteFooter)
		} else {
			prodejnyBanner.remove()
		}
	}
}
handleFooter()

if (document.body.classList.contains('type-glossary')) {
	const glossaryListing = document.querySelector('#glossary-listing')
	const glossaryLinks = document.querySelectorAll('#glossary-listing a')
	const groupedGlossaryLinks = {}
	glossaryLinks.forEach((link) => {
		const firstLetter = link.textContent.charAt(0).toUpperCase()
		if (!groupedGlossaryLinks[firstLetter]) {
			groupedGlossaryLinks[firstLetter] = []
		}
		groupedGlossaryLinks[firstLetter].push(link)
	})
	glossaryListing.innerHTML = ''
	for (const letter in groupedGlossaryLinks) {
		const groupWrapper = document.createElement('div')
		groupWrapper.classList.add('glossary-group')
		const groupHeading = document.createElement('h2')
		groupHeading.classList.add('glossary-title')
		groupHeading.innerText = letter
		groupWrapper.appendChild(groupHeading)
		const linksWrapper = document.createElement('div')
		groupedGlossaryLinks[letter].forEach((link) => {
			linksWrapper.appendChild(link)
		})
		groupWrapper.appendChild(linksWrapper)
		glossaryListing.appendChild(groupWrapper)
	}
}

const handleInstagram = () => {
	const instagramSection = document.querySelector('.custom-footer__instagram ')
	if (instagramSection) {
		const footer = document.querySelector('#footer')
		if (footer) {
			footer.before(instagramSection, footer)
		}
	}
}

const handleLastVisited = () => {
	const contentObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.nodeType !== 1) return

				let target = node.matches?.('.dkLabVisitedProductsNew') && node

				if (!target) {
					target = node.querySelector?.('.dkLabVisitedProductsNew')
				}

				if (target) {
					const whereToAppend = document.querySelector('.custom-footer__instagram')
					target.classList.add('container')
					target.style.marginBottom = '80px'

					if (whereToAppend) {
						whereToAppend.before(target)
					}

					contentObserver.disconnect()
				}
				const dvpnProducts = node.matches?.('.dvpnProducts') ? node : node.querySelector?.('.dvpnProducts')
				if (dvpnProducts && !dvpnProducts.classList.contains('slick-initialized')) {
					$(dvpnProducts).slick({
						slidesToShow: 5,
						slidesToScroll: 1,
						infinite: false,
						dots: true,
						arrows: true,
						responsive: [
							{ breakpoint: 1300, settings: { slidesToShow: 4 } },
							{ breakpoint: 1025, settings: { slidesToShow: 3 } },

							{ breakpoint: 768, settings: { slidesToShow: 2 } },
							{ breakpoint: 480, settings: { slidesToShow: 1 } },
						],
					})
				}
			})
		})
	})

	contentObserver.observe(document.body, {
		childList: true,
		subtree: true,
	})
}

handleLastVisited()

document.addEventListener('ShoptetDOMContentLoaded', handleLastVisited)
handleInstagram()
document.addEventListener('ShoptetDOMContentLoaded', handleInstagram)

// const observer = new MutationObserver(() => {
//   const addToCart = document.querySelector(".add-to-cart");
//   const linkIconChatAsCart = document.querySelector(
//     ".link-icon.chat.as-cart"
//   );
//   const customAddToCart = document.querySelector(".add-to-cart-wrapper");

//   if (linkIconChatAsCart && customAddToCart) {
//     if (!addToCart) {
//       document.body.classList.add("discontinued-product");

//       customAddToCart.appendChild(linkIconChatAsCart);
//     }
//     observer.disconnect();
//   }
// });

// observer.observe(document.body, { childList: true, subtree: true });

const handleCenaNaDotaz = () => {
	const observer = new MutationObserver(() => {
		const linkIconChatAsCart = document.querySelector('.link-icon.chat.as-cart')
		const customAddToCart = document.querySelector('.add-to-cart-wrapper')

		if (linkIconChatAsCart && customAddToCart) {
			customAddToCart.appendChild(linkIconChatAsCart)
			observer.disconnect()
		}
	})

	observer.observe(document.body, { childList: true, subtree: true })
}

if (document.body.classList.contains('discontinued-product')) {
	handleCenaNaDotaz()
}
